import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import colors from '@/styles/color.scss';
let LoadingBase = class LoadingBase extends Vue {
    color = colors.searchYellow;
    startTime = 0;
    alphaList = ['0.2', '0.2', '0.4', '0.4', '0.5', '0.5', '0.6', '0.6', '0.8', '0.8', '1', '1'];
    callback = (timestamp) => {
        if (timestamp - this.startTime > 200) {
            const lastAlpha = this.alphaList.pop();
            if (lastAlpha) {
                this.alphaList.unshift(lastAlpha);
            }
            this.startTime = timestamp;
        }
        window.requestAnimationFrame(this.callback);
    };
    mounted() {
        this.callback = window.requestAnimationFrame(this.callback);
    }
    beforeUnmount() {
        window.cancelAnimationFrame(this.callback);
        this.callback = null;
    }
};
LoadingBase = __decorate([
    Component({
        name: 'loadingBase'
    })
], LoadingBase);
export default LoadingBase;
